import { render } from "./BetanoCVH.vue?vue&type=template&id=a8942e78"
import script from "./BetanoCVH.vue?vue&type=script&lang=js"
export * from "./BetanoCVH.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__